import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { relayStylePagination } from '@apollo/client/utilities';
import { Hub } from 'aws-amplify/utils';
import { getIdToken } from '@sandtech-hub-monorepo/ui-auth-kit';

const httpLink = createHttpLink({
  uri: process.env['NX_GRAPHQL_API'],
});

const authMiddleware = setContext(async (_, { headers }) => {
  const idToken = await getIdToken();

  return {
    headers: {
      ...headers,
      ...(idToken ? { authorization: idToken } : {}),
    },
  };
});

export const client = new ApolloClient({
  link: from([authMiddleware, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      User: {
        keyFields: ['sandId'],
        fields: {
          notifications: relayStylePagination(),
        },
      },
      OnboardingPanel: {
        keyFields: ['sandId'],
      },
    },
  }),
});

Hub.listen('auth', (message) => {
  if (message.payload.event === 'signedOut') {
    // resetStore() would refetch every currently-mounted query synchronously,
    // before React re-renders with the cleared auth state — those requests
    // go out with no valid token and the API rejects them. clearStore() wipes
    // the cache (so no stale viewer data leaks into the next session) without
    // refetching anything, which is all we need since we're navigating away.
    client.clearStore();
  }
});
